import { type HttpPatch, mapServerError } from '@/shared/infra/http'
import type {
  PersonalNotificationPreferences,
  UpdatePersonalNotificationPreferences,
} from '@/shared/domain'

type UpdatePersonalNotificationPreferencesBody = {
  feedbackReply: boolean
}

type PersonalNotificationPreferencesResponse = { preferences: PersonalNotificationPreferences }

export class SupabaseUpdatePersonalNotificationPreferencesRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: UpdatePersonalNotificationPreferences = async ({ feedbackReply }) => {
    const body: UpdatePersonalNotificationPreferencesBody = { feedbackReply }

    try {
      const response = await this.http.patch<
        UpdatePersonalNotificationPreferencesBody,
        PersonalNotificationPreferencesResponse
      >({
        url: '/users/notification-preferences/personal',
        body,
      })
      return { preferences: response.preferences }
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
